<template>
    <v-dialog
        v-model="showDialog"
        width="700"
        :persistent="loading"
    >
        <v-card>
            <v-card-title style="background-color: #009688; color: white; word-break: break-word; overflow-wrap: break-word;">
                This will remove the member from the endorsement/confirmation letter.
            </v-card-title>
            <v-card-text style="max-height: 70vh; overflow-y: scroll; background-color: #EDFFFB;">
                <v-simple-table
                    dense
                    style="background-color: white; border-radius: 20px; padding: 10px 10px 0  10px; margin-top: 25px"
                    class="no-hover"
                >
                    <template #default>
                        <tbody>
                            <tr>
                                <td class="text-left">
                                    Member No.:
                                </td>
                                <td>{{ data.MEMB_N }}</td>
                            </tr>
                            <tr>
                                <td class="text-left">
                                    Member Name.:
                                </td>
                                <td>{{ data.LAST_M }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions style="background-color: #EDFFFB;">
                <span style="color: #555; font-size: 14px;">This action cannot be undone.</span>
                <v-spacer />
                <v-btn
                    outlined
                    class="white--text"
                    color="teal darken-1"
                    style="text-transform: none; width: 105px;"
                    :disabled="loading"
                    @click="showDialog = false"
                >
                    CANCEL
                </v-btn>
                <v-btn
                    color="teal darken-1 white--text"
                    class="white--text"
                    style="text-transform: none; width: 105px; font-weight: 600"
                    :loading="loading"
                    @click="handleDelete"
                >
                    DELETE
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['data', 'show', 'notif', 'requirePdfUpdate'],
    data:()=>({
        loading: false
    }),
    computed: {
        ...mapGetters(['deleteMemberFromEndorsementConfirmationData']),
        type() {
            if (this.data && this.data.TYPE) {
                return this.data.TYPE.toLowerCase()
            } else {
                return '-'
            }
        },
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        deleteMemberFromEndorsementConfirmationData(newVal) {
            if (newVal && newVal.status === 200) {
                this.requirePdfUpdate.value = true
                this.viewEndorsementConfirmation({ ID: this.data.ID })
                this.notif.type = 'success'
                this.notif.color = 'success'
                this.notif.timeout = 5000
                this.notif.msg = `${this.data.MEMB_N}-${this.data.LAST_M} has been removed.`
                this.notif.show = true
                this.notif.dismissible = false
                this.$emit('closeDialog')
            } else {
                this.notif.type = 'error'
                this.notif.color = 'error'
                this.notif.timeout = 5000
                this.notif.msg = newVal.state
                this.notif.show = true
                this.notif.dismissible = false
            }
            this.loading = false
        }
    },
    methods: {
        ...mapActions(['deleteMemberFromEndorsementConfirmation', 'viewEndorsementConfirmation']),
        handleDelete() {
            this.loading = true
            this.deleteMemberFromEndorsementConfirmation({ ID: this.data.ID, MEMB_N: this.data.MEMB_N })
        }
    }
}
</script>

<style scoped>
.no-hover tbody tr:hover {
  background-color: transparent !important;
}
</style>
